<template>
  <div class="wrapper">
    <Header class="header" data-title="쿠폰함"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="full hr mg0">
          <div class="banner">
            <a>
              <span class="img" @click="$router.push('/benefits/welmallBenefits')">
                <!-- <img src="@/../static/img/mw/content/mybef_banner1.png" alt="" /> -->
                <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1607584062139_mybef_banner.png" alt="" />
              </span>
            </a>
          </div>
        </section>
        <!-- pageTab (s) -->
        <ul class="tabList pageTab hr">
          <li :class="{ on: this.tab }" @click="goMyCoupon">내가 받은 쿠폰</li>
          <li :class="{ on: !this.tab }" @click="goDownCoupon">다운가능 쿠폰</li>
        </ul>
        <!-- pageTab (e) -->
        <section class="full hr mb0">
          <div class="sortArea filter mb0">
            <div class="lcont">
              <span class="txt">
                총
                <em v-if="tab">{{ myCouponList.length }}</em>
                <em v-if="!tab">{{ downCouponList.length }}</em>
                개
              </span>
            </div>
            <div class="rcont">
              <select class="btnTxt_sort sel" title="상품정렬 선택" v-model="filter" @change="filterCouponList($event)">
                <option value="all">전체</option>
                <option value="CPAP0001">렌탈</option>
                <option value="CPAP0002">구매</option>
                <option value="CPAP0003">정기배송</option>
              </select>
              <select class="btnTxt_sort sel" title="정렬기준 선택" v-if="tab" v-model="orderBy" @change="filterCouponList($event)">
                <option value="calcDt" selected="selected">유효기간순</option>
                <option value="issuDt">최근발급순</option>
              </select>
            </div>
          </div>
        </section>

        <!-- 내가 받은 쿠폰 -->
        <section class="mt0" v-if="tab && myCouponList.length > 0">
          <ul class="myCuponWrap">
            <li v-for="(coupon, index) in myCouponList" :key="index">
              <div v-if="coupon.calcDt >= 0" class="block">
                <!--<div class="info" :class="'color' + (index + 1)">-->
                <div class="info">
                  <p class="tit" v-if="(coupon.discountAmount > 0 || coupon.discountRate > 0) && coupon.discTpCd == 'CM630001'">
                    <em>{{ coupon.discountAmount | currency }}</em>
                    원 할인
                  </p>
                  <p class="tit" v-else-if="(coupon.discountAmount > 0 || coupon.discountRate > 0) && coupon.discTpCd == 'CM630002'">
                    <em>{{ coupon.discountRate }}%</em>
                    할인
                  </p>
                  <p class="tit" v-else>
                    <em>{{ coupon.convTxt }}</em>
                  </p>
                  <p class="copy">{{ coupon.title }}</p>
                  <p class="period">
                    {{ coupon.startDate | dateFormatter('-') }} ~ {{ coupon.endDate | dateFormatter('-') }}
                    <span>({{ coupon.calcDt }}일 남음)</span>
                  </p>
                </div>
                <div class="btnWrap">
                  <button type="button" class="btn_s" disabled="disabled">발급완료</button>
                  <button type="button" class="btn_s" @click="showDetail(index)">
                    <span v-show="detail[index]">접기</span>
                    <span v-show="!detail[index]">상세보기</span>
                  </button>
                </div>
                <div class="desc" v-show="detail[index]">
                  <ul class="txtList_dash">
                    <li v-for="(conditionObj, index) in coupon.conditions" :key="index">{{ conditionObj.condition }}</li>
                  </ul>
                </div>
                <a class="btnView active" @click="detailPop(coupon.couponId)">적용상품보기</a>
              </div>

              <div v-else class="block">
                <!--<div class="info" :class="'color' + (index + 1)">-->
                <div class="info">
                  <p class="tit" v-if="(coupon.discountAmount > 0 || coupon.discountRate > 0) && coupon.discTpCd == 'CM630001'">
                    <em>{{ coupon.discountAmount | currency }}</em>
                    원 할인
                  </p>
                  <p class="tit" v-else-if="(coupon.discountAmount > 0 || coupon.discountRate > 0) && coupon.discTpCd == 'CM630002'">
                    <em>{{ coupon.discountRate }}%</em>
                    할인
                  </p>
                  <p class="tit" v-else>
                    <em>{{ coupon.convTxt }}</em>
                  </p>
                  <p class="copy">{{ coupon.title }}</p>
                  <p class="period">
                    {{ coupon.startDate | dateFormatter('-') }} ~ {{ coupon.endDate | dateFormatter('-') }}
                    <span>종료</span>
                  </p>
                </div>
                <div class="btnWrap">
                  <button type="button" class="btn_s" disabled="disabled">발급완료</button>
                  <button type="button" class="btn_s" @click="showDetail(index)">
                    <span v-show="detail[index]">접기</span>
                    <span v-show="!detail[index]">상세보기</span>
                  </button>
                </div>
                <div class="desc" v-show="detail[index]">
                  <ul class="txtList_dash">
                    <li v-for="(conditionObj, index) in coupon.conditions" :key="index">{{ conditionObj.condition }}</li>
                  </ul>
                </div>
                <a class="btnView">적용상품보기</a>
              </div>
            </li>
          </ul>
        </section>
        <section class="hr" v-if="tab && myCouponList.length == 0">
          <div class="resultMsg txtOnly">
            <p class="copy">사용 가능한 쿠폰이 없습니다.</p>
          </div>
        </section>

        <!-- 다운가능 쿠폰 -->
        <section class="mt0" v-if="!tab && downCouponList.length > 0">
          <div class="btnArea mt20">
            <button type="button" class="btn_p m download" @click="getAllCoupon"><span>쿠폰 모두받기</span></button>
          </div>

          <ul class="myCuponWrap">
            <li v-for="(coupon, index) in downCouponList" :key="index">
              <div class="block">
                <!--<div class="info" :class="'color' + (index + 1)">-->
                <div class="info">
                  <p class="tit" v-if="(coupon.discountAmount > 0 || coupon.discountRate > 0) && coupon.discTpCd == 'CM630001'">
                    <em>{{ coupon.discountAmount | currency }}</em>
                    원 할인
                  </p>
                  <p class="tit" v-else-if="(coupon.discountAmount > 0 || coupon.discountRate > 0) && coupon.discTpCd == 'CM630002'">
                    <em>{{ coupon.discountRate }}%</em>
                    할인
                  </p>
                  <p class="tit" v-else>
                    <em>{{ coupon.convTxt }}</em>
                  </p>
                  <p class="copy">{{ coupon.title }}</p>
                  <p class="period">
                    {{ coupon.startDate | dateFormatter('-') }} ~ {{ coupon.endDate | dateFormatter('-') }}
                    <span>({{ coupon.restDate }}일 남음)</span>
                  </p>
                </div>
                <div class="btnWrap">
                  <button type="button" class="btn_g download" @click="getCoupon(coupon.couponId)"><span>쿠폰받기</span></button>
                  <button type="button" class="btn_s btnMore" @click="showDetail(index)">
                    <span v-show="detail[index]">접기</span>
                    <span v-show="!detail[index]">상세보기</span>
                  </button>
                </div>
                <div class="desc" v-show="detail[index]">
                  <ul class="txtList_dash">
                    <li v-for="(conditionObj, index) in coupon.conditions" :key="index">{{ conditionObj.condition }}</li>
                  </ul>
                </div>
                <a class="btnView" @click="detailPop(coupon.couponId)">적용상품보기</a>
              </div>
            </li>
          </ul>
        </section>
        <section class="hr" v-if="!tab && downCouponList == 0">
          <div class="resultMsg txtOnly">
            <p class="copy">다운로드 가능한 쿠폰이 없습니다.</p>
          </div>
        </section>
        <!-- 공통 배너 -->
        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop
      v-if="confirmPop"
      @cancel="confirmPop = false"
      @confirm="$router.push({ name: 'login', params: { redirect: 'benefitsCoupon' } })"
      @close="confirmPop = false"
    >
      <p v-html="msg"></p>
    </ConfirmPop>
    <BenefitsEventDetailPop
      v-if="benefitsEventDetailPopFlag"
      :couponIndex="couponIndex"
      @close="benefitsEventDetailPopFlag = false"
    ></BenefitsEventDetailPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import { LOGIN_REQUIRE } from '@/store/message.type';
import CommonBanner from '@/components/banner/CommonBanner';
import MessagePop from '@/components/popup/MessagePop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import BenefitsEventDetailPop from '@/components/popup/BenefitsEventDetailPop';

export default {
  name: 'benefitsCoupon',
  components: { BenefitsEventDetailPop, CommonBanner, MessagePop, ConfirmPop },
  mounted() {
    // this.userInfo = JwtService.getUserInfo();
    if (JwtService.getToken() && !this.$route.params.downCoupon) {
      this.getMyCouponList();
    } else {
      this.tab = false;
    }
    this.getDownCouponList();
  },
  data: function () {
    return {
      tab: true, // 내가받은쿠폰 다운가능쿠폰 전환
      detail: [], // 쿠폰 내용 상세보기
      myCouponList: [], // 내가 받은 쿠폰
      downCouponList: [], // 다운가능 쿠폰
      benefitsEventDetailPopFlag: null, // 적용상품보기 팝업
      msg: null, // 팝업 메세지
      messagePop: false, // 메세지 팝업
      confirmPop: false, // 확인 팝업
      couponIndex: null, // 적용가능 상품용 쿠폰ID
      filter: 'all',
      orderBy: 'calcDt',
    };
  },
  methods: {
    async goMyCoupon() {
      if (!this.checkAuth()) return;
      this.detail = [];
      await this.getMyCouponList();
      this.tab = true;
    },
    async goDownCoupon() {
      this.detail = [];
      await this.getDownCouponList();
      this.tab = false;
    },
    showDetail(index) {
      this.$set(this.detail, index, !this.detail[index]);
    },
    // TODO 쿠폰 다운로드 (개별, 전체)
    getAllCoupon() {
      ApiService.service('GET', `user/coupon/available/filter/all`)
        .then(({ data }) => {
          console.log(data);
          this.downCouponList = data.result;
          if (this.downCouponList.length == 0) {
            this.msg = `다운로드 가능한 쿠폰이 없습니다.`;
            this.messagePop = true;
            return;
          }
          let couponId = '';
          for (var idx in this.downCouponList) {
            couponId += idx == 0 ? this.downCouponList[idx].couponId : ',' + this.downCouponList[idx].couponId;
          }
          this.getCoupon(couponId);
        })
        .catch(({ response }) => {
          console.log(response);
          this.msg = `서비스 이용에 불편을 드려 죄송합니다.<br>문제 지속 발생 시 고객센터로 문의 바랍니다.`;
          this.messagePop = true;
        });
    },
    getCoupon(couponIds) {
      if (!this.checkAuth()) return;
      JwtService.getUserInfo().userId;
      let coupons = [];
      let couponArray = couponIds.split(',');
      for (let couponId of couponArray) {
        let coupon = {
          couponId: couponId,
        };
        coupons.push(coupon);
      }
      let params = {
        request: {
          couponInfo: coupons,
          serviceType: 'app',
        },
      };
      ApiService.service('POST', 'user/auth/coupon', params)
        .then(({ data }) => {
          if (data.isSucceed) {
            // TODO API 리턴 메세지 확인 필요
            this.msg = '쿠폰이 다운로드 되었습니다.';
            this.messagePop = true;
            this.getDownCouponList(); // 다운받을 수 있는 쿠폰 리스트 초기화
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
          this.msg = `서비스 이용에 불편을 드려 죄송합니다.<br>문제 지속 발생 시 고객센터로 문의 바랍니다.`;
          this.messagePop = true;
        });
    },
    filterCouponList() {
      if (this.tab) this.getMyCouponList();
      else this.getDownCouponList();
    },
    getMyCouponList() {
      ApiService.service('GET', `user/auth/coupon/downloaded/filter/${this.filter}/orderby/${this.orderBy}`)
        .then(({ data }) => {
          console.log(data);
          this.myCouponList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    getDownCouponList() {
      ApiService.service('GET', `user/coupon/available/filter/${this.filter}`)
        .then(({ data }) => {
          console.log(data);
          this.downCouponList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    checkAuth() {
      if (JwtService.getToken()) {
        return true;
      } else {
        // 비로그인 내가 받은 쿠폰 클릭했을때
        this.msg = LOGIN_REQUIRE;
        this.confirmPop = true;
        return false;
      }
    },
    detailPop(couponId) {
      this.couponIndex = couponId;
      this.benefitsEventDetailPopFlag = true;
    },
  },
};
</script>
